/**
 * 企業選択共通
 */
<script >
export default {
	data: function(){
		return {
			m_nCompanyCode:-1,
			m_nCompanyName: "",
			m_bCompanyInit:true,		//!< 初期化フラグ
			m_nResetCount:0,
		}
	},
	computed: {
		get_company_code_string: function(){
			if(this.r_settings && this.r_settings.codes && this.r_settings.codes.company && this.r_settings.codes.company.max){
				return String(this.m_nCompanyCode).padStart(String(this.r_settings.codes.company.max).length, '0');
			}else{
				return String(this.m_nCompanyCode).padStart(6, '0');
			}
		},
		display_company_name:function(){
			if(this.m_nCompanyCode != -2){
				return this.get_company_code_string + ":" + this.m_nCompanyName;
			}else{
				return "("+this.m_nCompanyName+")";
			}
		},
		company_no_select:function(){
			if(this.m_nCompanyCode > 0){
				return false;
			}
			return true;
		},
	},
	watch:{
	},
	methods: {
		/**
		 * 初期化処理 <br>
		 * ******* 内部処理 *******<br>
		 *  <br>
		 *
		 * @function  initCompany
		 * @returns event
		 * @instance
		 */
		initCompany: function(){
			//! 初期処理フラグ
			this.m_bCompanyInit = true;
			// 企業を取得
			var target = this;
			var callback = function(rResult, rResponse){target.onLoadCompany(rResult, rResponse);}
			this.manager.sendCompany({},callback);
		},
		/**
		 * 初期化処理(指定なし) <br>
		 * ******* 内部処理 *******<br>
		 *  <br>
		 *
		 * @function  initCompany
		 * @returns event
		 * @instance
		 */
		initNoSelectCompany: function(){
			this.m_nCompanyCode = -2;
			this.m_nCompanyName = this.r_messages.not_select;
			this.m_bCompanyInit = false;
		},
		/**
		 * 企業データ初期化イベント <br>
		 * ******* 内部処理 *******<br>
		 *  <br>
		 *
		 * @function  onLoadCompany
		 * @returns event
		 * @instance
		 */
		onLoadCompany:function( result, response){
			console.log("onLoadCompany");
			if ( result == 0 ) {
				for ( var index in response.data.rec) {
					this.m_nCompanyName = response.data.rec[index].company_name;
					this.m_nCompanyCode = response.data.rec[index].company_code;
					break;
				}
				this.m_bCompanyInit = false;
				this.onLoadEnd();
			} else if ( this.m_nResetCount < 5) {
				this.m_nResetCount++;
				var target = this;
				var callback = function(rResult, rResponse){target.onLoadCompany(rResult, rResponse);}
				this.manager.sendCompany({},callback);
			} else {

			}
		},
		/*
		 * 検索処理終了 for override 
		 */
		onLoadEnd:function(){

		},
		/**
		 * 企業変更イベント for override<br>
		 * ******* 内部処理 *******<br>
		 *  <br>
		 *
		 * @function  initCompany
		 * @returns event
		 * @instance
		 */
		onChangeCompany: function( info  ){
			console.log("onChangeCompany");
			this.m_nCompanyName = info.company_name;
			this.m_nCompanyCode = info.company_code;
		},
		/*
		 * 確認ダイアログを表示する。
		 * OKボタンが押された場合コールバックを呼ぶ。
		 */
		doCheckDialog: function(msg_confirm, okCallback, ngCallback = null) {
			// アクティブな要素のフォーカスを外す
			this.blurActiveElement();
			var target = this;
			var isClicked = false;
			$.confirm({ // 確認ダイアログを表示する。
				title: '',
				content: msg_confirm,
				buttons: {
					ok: {
						text: this.r_messages.yes_btn,
						btnClass: 'btn-ok',
						action: function() {
							if (isClicked) return; // ダブルクリック抑制
							isClicked = true;
							okCallback();
						}
					},
					cancel: {
						text: this.r_messages.no_btn,
						btnClass: 'btn-cancel',
						action: function() {
							if ( ngCallback != null ) {
								ngCallback();
							}
						}
					}
				},
				onOpen: function(){
					target.toggleTabIndexConfirm(true);
				},
				onClose: function(){
					target.toggleTabIndexConfirm(false);
				},
			});
		},
		blurActiveElement: function() {
			// アクティブな要素のフォーカスを外す
			document.activeElement.blur();
		},
	},
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/common/select/company.mixin.vue